import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import moment from "moment";
import MyTransactions from "../components/dashboard/MyTransactions";
import ChartInfo from "../components/dashboard/ChartInfo";
import "../styles/transactions.css";
import Loader from "../components/Loader";

function Transactions({ user }) {
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({
    totalCredits: 0,
    totalDebits: 0,
    totalTransactions: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const userId = user?.uid;
        if (!userId) {
          return;
        }

        const userDoc = await getDoc(doc(db, "users", userId));
        if (userDoc.exists()) {
          const userData = userDoc.data();

          let fetchedTransactions = (userData.transactions || []).filter(
            (transaction) => transaction.account !== "Trading",
          );

          const sortedTransactions = fetchedTransactions.sort((a, b) => {
            const dayA = moment(a.date).startOf("day");
            const dayB = moment(b.date).startOf("day");
            if (dayA.isBefore(dayB)) {
              return 1;
            } else if (dayA.isAfter(dayB)) {
              return -1;
            }
            return moment(b.date).isBefore(moment(a.date)) ? 1 : -1;
          });

          setTransactions(sortedTransactions);

          const totalCredits = sortedTransactions
            .filter((transaction) => transaction.type === "credit")
            .reduce((acc, transaction) => acc + transaction.amount, 0);

          const totalDebits = sortedTransactions
            .filter((transaction) => transaction.type === "debit")
            .reduce((acc, transaction) => acc + transaction.amount, 0);

          setSummary({
            totalCredits,
            totalDebits,
            totalTransactions: sortedTransactions.length,
          });
        }
      } catch (error) {
        console.error("Error fetching transactions: ", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.uid) {
      fetchTransactions();
    }
  }, [user]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="transactions-page">
      <ChartInfo transactions={transactions} summary={summary} />
      <MyTransactions user={user} showFilter={true} />
    </div>
  );
}

export default Transactions;
